import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { detectAlpha2Country } from '../../../utils/country';
import { useStores } from '../stores';
import txt from '../utils/txt';

const PageViewTracker = () => {
  const location = useLocation();
  const { userStore, orderStore } = useStores();
  const { isLogged, user } = userStore;
  const { isLoadingOrders, orders, orderTypes } = orderStore;
  const brand = process.env.REACT_APP_BRAND === 'PW' ? "deagostini" : "fanhome";
  const lang = detectAlpha2Country();

  const hasSubscriptions =
    orders.length > 0 &&
    orders.some((el) => el.type === orderTypes.subscription);
  const hasBKIs =
    orders.length > 0 && orders.some((el) => el.type === orderTypes.backissue);

  const pageTypes = {
    reset: {
      path: '/myarea/p/reset',
      pageName: 'account/recover-password',
      pageType: 'account/recover-password',
    },
    login: {
      path: '/myarea/',
      pageName: 'my-account/login',
      pageType: 'my-account/login',
    },
  };

  const handlePageName = (location) => {
    const match = Object.values(pageTypes).find(
      (page) => page.path === location.pathname + location.search,
    );

    if (match) {
      return match.pageName;
    }

    return location.pathname + location.search;
  };

  const handlePageType = (location) => {
    const match = Object.values(pageTypes).find(
      (page) => page.path === location.pathname + location.search,
    );

    if (match) {
      return match.pageName;
    }

    return 'myarea';
  };

  useEffect(() => {
    const push = async () => {
      if (window.snakeAnalytics) {
        window.snakeAnalytics.push([
          'event',
          'page_view',
          {
            context: {
              im_page_name: handlePageName(location),
              im_page_type: handlePageType(location),
              im_user_logged: isLogged ? 'yes' : 'no',
              im_language: lang,
              im_country: lang,
              im_brand: brand,
            },
            ...(isLogged
              ? {
                  user: {
                    im_user_id: user?.UID,
                    im_user_suscriptor: hasSubscriptions
                      ? hasBKIs
                        ? 'both'
                        : 'yes'
                      : 'no',
                    first_name: user.name,
                    last_name: user.lastName,
                    email: await txt.hashEmail(user.email),
                    phone_number: user?.phone,
                    home_address_street: user.billingAddress?.addressLine1,
                    home_address_city: user.billingAddress?.city,
                    home_address_postal_code: user.billingAddress?.postalCode,
                    home_address_country: user.billingAddress?.country,
                  },
                }
              : null),
          },
        ]);
      }
    };
    if ((!isLoadingOrders || !isLogged) && location.pathname !== "/myarea" ) {
      push();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, isLoadingOrders, isLogged]);

  return null;
};

export default PageViewTracker;
